import { render, staticRenderFns } from "./EdutalkBrank.vue?vue&type=template&id=b81e0666"
import script from "./EdutalkBrank.vue?vue&type=script&lang=js"
export * from "./EdutalkBrank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports